document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('sticky-cart');
  if (!bar) return;
  var submitWrap = bar.querySelector('.sticky-submit-wrap');

  function startStickyLoading() {
    if (!submitWrap) return;

    clearTimeout(bar._stickyLoadingFallback);
    submitWrap.classList.add('is-loading');
    bar._stickyLoadingFallback = setTimeout(function () {
      submitWrap.classList.remove('is-loading');
    }, 1200);
  }

  bar.addEventListener('click', function (e) {
    var btn = e.target.closest('.sticky-qty-btn');
    if (!btn) return;
    var input = bar.querySelector('.sticky-qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (btn.classList.contains('sticky-qty-plus')) {
      var max = parseInt(input.getAttribute('max'), 10);
      if (!max || val < max) input.value = val + 1;
    } else if (btn.classList.contains('sticky-qty-minus')) {
      if (val > 1) input.value = val - 1;
    }
  });

  var qtyWrap = bar.querySelector('.sticky-qty-wrapper');
  var qtyInput = bar.querySelector('.sticky-qty-input');
  var stock = {};
  try { stock = JSON.parse(qtyWrap.getAttribute('data-stock')) || {}; } catch (err) {}

  function applyQtyRules() {
    if (!qtyWrap || !qtyInput) return;
    var mode = qtyWrap.getAttribute('data-qty-mode');
    var idField = bar.querySelector('.formVariantId');
    var available = idField && stock.hasOwnProperty(idField.value) ? stock[idField.value] : -1;
    var hide = mode === 'hide' || (mode === 'multiple' && available !== -1 && available <= 1);
    qtyWrap.style.display = hide ? 'none' : '';
    if (available > 0) qtyInput.setAttribute('max', available); else qtyInput.removeAttribute('max');
    if (hide || (available > 0 && parseInt(qtyInput.value, 10) > available)) qtyInput.value = 1;
  }

  applyQtyRules();
  document.addEventListener('change', function () { setTimeout(applyQtyRules, 50); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.swatch-element, .swatches__form--label')) setTimeout(applyQtyRules, 150);
  });

  document.addEventListener('click', function (e) {
    var stickySubmit = e.target.closest('#sticky-cart .js-ajax-submit');
    if (!stickySubmit) return;
    if (stickySubmit.disabled || stickySubmit.classList.contains('disabled')) return;
    startStickyLoading();
  }, true);
});

/* Position the cart icon directly in front of the add-to-cart text */
(function () {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');

  // The label changes to "Uitverkocht" when a variant is sold out. Measure the add-to-cart label
  // instead, so the icon stays in the same spot when switching variants.
  var addLabel = '';
  try {
    var form = document.querySelector('[data-product-form]');
    addLabel = JSON.parse(form.getAttribute('data-product-form')).button || '';
  } catch (err) {}

  function placeIcons() {
    var buttons = document.querySelectorAll('.product-blocks input.AddtoCart, #sticky-cart input.AddtoCart');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var cs = window.getComputedStyle(btn);
      var size = parseFloat(cs.getPropertyValue('--atc-icon-size'));
      if (!size) continue;
      var gap = parseFloat(cs.getPropertyValue('--atc-icon-gap')) || 10;
      ctx.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      var spacing = parseFloat(cs.letterSpacing) || 0;
      if (!addLabel && !btn.disabled) addLabel = btn.value || '';
      var label = addLabel || btn.value || '';
      var textWidth = ctx.measureText(label).width + spacing * label.length;
      var x = btn.clientWidth / 2 - textWidth / 2 - size - gap;
      btn.style.setProperty('--atc-icon-x', Math.max(8, x) + 'px');
    }
  }

  function placeSoon() {
    setTimeout(placeIcons, 150);
    setTimeout(placeIcons, 700);
  }

  // Keep the icon aligned when a button changes width (e.g. the quantity stepper shows or hides).
  if (window.ResizeObserver) {
    var observer = new ResizeObserver(placeIcons);
    document.querySelectorAll('.product-blocks input.AddtoCart, #sticky-cart input.AddtoCart').forEach(function (btn) {
      observer.observe(btn);
    });
  }

  window.addEventListener('load', placeIcons);
  window.addEventListener('resize', placeIcons);
  document.addEventListener('DOMContentLoaded', placeIcons);
  document.addEventListener('click', placeSoon);
  document.addEventListener('change', placeSoon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeIcons);
})();
